import { FormattedMessage } from 'react-intl';
import { Navigate, Outlet } from 'react-router-dom';

import { catchAll } from '@sorare/routing';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  NBA_HOME,
  NBA_PLAY_CHASE,
  NBA_PLAY_LINEUPS,
  NBA_PLAY_LOBBY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { glossary, navLabels } from '@sorare/core/src/lib/glossary';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const Layout = () => {
  const { currentUser } = useCurrentUserContext();

  // Make sure existing users who are logged in are redirected to the home page
  if (!currentUser?.nbaUserProfile?.onboarded) {
    return <Navigate to={NBA_HOME} replace />;
  }

  return (
    <RequireAuth>
      <ContentWithStickyHeader
        header={
          <>
            <PageHeader text={glossary.play} disableBackBrowser />
            <TabBar variant="flat" fullWidth>
              <Tab matches={[catchAll(NBA_PLAY_LINEUPS)]} to={NBA_PLAY_LINEUPS}>
                <FormattedMessage {...glossary.lineups} />
              </Tab>
              <Tab matches={[catchAll(NBA_PLAY_LOBBY)]} to={NBA_PLAY_LOBBY}>
                <FormattedMessage {...navLabels.lobby} />
              </Tab>
              <Tab matches={[catchAll(NBA_PLAY_CHASE)]} to={NBA_PLAY_CHASE}>
                <FormattedMessage {...glossary.championshipChase} />
              </Tab>
            </TabBar>
          </>
        }
      >
        <Outlet />
      </ContentWithStickyHeader>
    </RequireAuth>
  );
};

export default Layout;
